export interface NotificationData {
  id: string;
  title: string;
  message: string;
  type: NotificationType;
  priority: NotificationPriority;
  isRead: boolean;
  createdAt: Date;
  actionUrl?: string;
  actionLabel?: string;
  metadata?: Record<string, any>;
}

// Keep the old name for backward compatibility
export type Notification = NotificationData;

export enum NotificationType {
  BOOKING = 'booking',
  PAYMENT = 'payment',
  FLEET = 'fleet',
  SYSTEM = 'system',
  USER = 'user',
  BLOG = 'blog',
  MAINTENANCE = 'maintenance',
  SECURITY = 'security'
}

export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

export interface NotificationSettings {
  soundEnabled: boolean;
  emailNotifications: boolean;
  pushNotifications: boolean;
  notificationTypes: {
    [key in NotificationType]: boolean;
  };
}

export interface NotificationContextType {
  notifications: NotificationData[];
  unreadCount: number;
  isLoading: boolean;
  settings: NotificationSettings;
  addNotification: (notification: Omit<NotificationData, 'id' | 'createdAt' | 'isRead'>) => void;
  markAsRead: (id: string) => void;
  markAllAsRead: () => void;
  deleteNotification: (id: string) => void;
  clearAllNotifications: () => void;
  updateSettings: (settings: Partial<NotificationSettings>) => void;
  playNotificationSound: () => void;
}